import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/lib/Form';

import CommonFields from '../CommonFields/CommonFields';

import submit from './submit';
import validate from './validate';
import messages from '../../locale/messages';

import 'react-phone-input-2/lib/style.css';
import s from './EditProfileForm.css';
import bt from '../../components/commonStyle.css';

class EditProfileForm extends Component {

  componentDidMount() {
    const { change, initialValues } = this.props;
    let loggedInEmail;
    if (initialValues && initialValues.email) {
      loggedInEmail = initialValues.email;
    }
    change('loggedinEmail', loggedInEmail);
  }

  UNSAFE_componentWillReceiveProps() {
    const { change, initialValues } = this.props;
    let loggedInEmail;
    if (initialValues && initialValues.email) {
      loggedInEmail = initialValues.email;
    }
    change('loggedinEmail', loggedInEmail);
  }

  render() {

    const { error, handleSubmit, initialValues } = this.props;
    const { formatMessage } = this.props.intl;
    const title = <span>{formatMessage(messages.editProfileInfo)}</span>;
    return (
      <div className={cx('inputFocusColor', 'commonListingBg', 'inputDateHide', 'noMarginBottom')} >
        {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        <h3 className={cx(bt.listingTitleText, bt.space5)}>{title}</h3>
        <Form onSubmit={handleSubmit(submit)}>
          <CommonFields initialValues={initialValues} userId={initialValues?.userId} />
        </Form>
      </div >
    )
  }
}

EditProfileForm = reduxForm({
  form: 'EditProfileForm', // a unique name for this form
  validate,
})(EditProfileForm);

const mapState = (state) => ({
  initialValues: state?.account?.data
});
const mapDispatch = {
  change
};

export default compose(injectIntl, withStyles(s, bt), connect(mapState, mapDispatch))(EditProfileForm);